import Modal from '@lingxi-common-component/sirius-ui/SiriusModal';
import { apiHolder } from 'api';
import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.module.scss';
const eventApi = apiHolder.api.getEventApi();
const MiniAppModal = React.memo((props) => {
    const { url, windowSize = { width: 600, height: 528 }, onClose } = props;
    const ghostStyle = React.useMemo(() => ({ minWidth: Math.max(windowSize.width - 40, 0) + 'px', minHeight: Math.max(windowSize.height - 88, 0) + 'px' }), [windowSize]);
    return (React.createElement(Modal, { width: windowSize.width, visible: true, footer: null, getContainer: false, onCancel: onClose, centered: true },
        React.createElement("div", { className: styles.miniappModalGhost, style: ghostStyle }),
        React.createElement("iframe", { className: styles.miniappIframe, src: url, style: { minWidth: windowSize.width + 'px', minHeight: windowSize.height + 'px' } })));
});
const openMiniAppModal = (prop) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    ReactDOM.render(React.createElement(MiniAppModal, Object.assign({}, prop)), container);
    return () => {
        ReactDOM.unmountComponentAtNode(container);
        document.body.removeChild(container);
    };
};
export const bindMiniAppModal = () => {
    let _destroyCallback = null;
    const evtId = eventApi.registerSysEventObserver('miniapp', {
        func: ev => {
            if (ev && ev.eventData) {
                if (ev.eventStrData === 'open') {
                    const { url, windowSize, title } = ev.eventData;
                    if (typeof _destroyCallback === 'function') {
                        _destroyCallback();
                    }
                    _destroyCallback = openMiniAppModal({
                        url,
                        windowSize,
                        title,
                        onClose: () => {
                            eventApi.sendSysEvent({
                                eventName: 'miniapp',
                                eventStrData: 'close',
                                eventData: {},
                            });
                            typeof _destroyCallback === 'function' && _destroyCallback();
                            _destroyCallback = null;
                        },
                    });
                }
                else if (ev.eventStrData === 'dismiss') {
                    typeof _destroyCallback === 'function' && _destroyCallback();
                    _destroyCallback = null;
                }
            }
        },
    });
    return () => {
        eventApi.unregisterSysEventObserver('miniapp', evtId);
    };
};
